import { render, staticRenderFns } from "./skuViewChannelCode.vue?vue&type=template&id=4f1871f9&"
import script from "./skuViewChannelCode.vue?vue&type=script&lang=ts&"
export * from "./skuViewChannelCode.vue?vue&type=script&lang=ts&"
import style0 from "./skuViewChannelCode.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports